import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export default function AdminLegal() {
  const [pages, setPages] = useState([]);
  const [active, setActive] = useState(null);

  const load = async () => {
    const { data } = await api.get("/admin/legal");
    setPages(data);
    if (data.length && !active) setActive(data[0]);
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/legal", { slug: active.slug, title: active.title, content: active.content });
      toast.success("Saved");
      load();
    } catch (e) {
      toast.error("Failed");
    }
  };

  return (
    <>
      <PageHeader eyebrow="Legal" title="Legal pages CMS" description="Edit publicly served legal documents." testid="admin-legal-header" />
      <div className="px-4 sm:px-6 md:px-10 py-8 grid grid-cols-12 gap-3">
        <aside className="col-span-3 border border-border">
          {pages.map((p) => (
            <button
              key={p.slug}
              onClick={() => setActive(pages.find((x) => x.slug === p.slug) || p)}
              className={`w-full text-left px-4 py-3 border-b border-border text-sm hover:bg-muted ${active?.slug === p.slug ? "bg-muted font-semibold" : ""}`}
              data-testid={`legal-nav-${p.slug}`}
            >
              <div className="label-eyebrow text-[9px]">{p.slug}</div>
              <div>{p.title}</div>
            </button>
          ))}
        </aside>
        <main className="col-span-9">
          {active && (
            <form onSubmit={save} className="space-y-4">
              <div className="grid md:grid-cols-2 gap-3">
                <div>
                  <Label className="label-eyebrow mb-2 inline-block">Slug</Label>
                  <Input value={active.slug} disabled className="font-mono" data-testid="legal-slug-input" />
                </div>
                <div>
                  <Label className="label-eyebrow mb-2 inline-block">Title</Label>
                  <Input value={active.title} onChange={(e) => setActive({ ...active, title: e.target.value })} data-testid="legal-title-input" />
                </div>
              </div>
              <div>
                <Label className="label-eyebrow mb-2 inline-block">Content (Markdown / plain)</Label>
                <Textarea rows={22} value={active.content} onChange={(e) => setActive({ ...active, content: e.target.value })} className="font-mono text-xs" data-testid="legal-content-input" />
              </div>
              <Button type="submit" className="rounded-none" data-testid="legal-save-btn">Save page</Button>
            </form>
          )}
        </main>
      </div>
    </>
  );
}
